// La moneda del anuncio: una sola para el anuncio, sus alojamientos y sus tarifas.
export const monedaAnuncio = {
  chipTitle: "Währung des Inserats",
  change: "Ändern",
  mismatchDot: "Die Währungen dieses Inserats stimmen nicht überein",
  channexText: "Dieses Inserat ist mit Channex verbunden. Dort lässt sich die Währung eines Tarifs nicht ändern: Er muss neu angelegt werden. Schreiben Sie uns, und wir erledigen das, ohne Ihre OTA-Verkäufe zu unterbrechen.",
  channexOnly: "Es ist mit Channex verbunden: Es kann nur {currency} verwenden, die Währung seiner Tarife dort.",
  modal: {
    title: "Währung des Inserats",
    lead: "In dieser Währung berechnen Sie die Gäste dieses Inserats.",
    scope: "Sie ändert sich gleichzeitig für das Inserat, alle seine Unterkünfte und seine Tarife. Zahlungslinks, der KI-Agent und der späte Check-out verwenden diese Währung.",
    label: "Währung",
    mismatch: "Derzeit stimmen sie nicht überein: Das Inserat sagt {listing}, seine Unterkünfte kassieren in {units}. Beim Speichern wird alles einheitlich.",
    channexTitle: "Hier nicht änderbar",
    cancel: "Abbrechen",
    close: "Verstanden",
    save: "Speichern",
    saving: "Wird gespeichert…",
    saved: "Währung des Inserats auf {currency} geändert.",
    error: "Die Währung konnte nicht geändert werden. Bitte erneut versuchen.",
  },
  sugerencia: {
    titleCountry: "Dieses Inserat kassiert in {current}",
    textCountry: "In {country} wird meist in {suggested} bezahlt. Wenn Sie sie ändern, verwenden Zahlungslinks, der KI-Agent und der späte Check-out {suggested}.",
    titleMismatch: "Die Währungen dieses Inserats stimmen nicht überein",
    textMismatch: "Das Inserat sagt {listing}, seine Unterkünfte kassieren in {units}. Behalten Sie nur eine, damit das, was die KI nennt, und das, was berechnet wird, übereinstimmen.",
    useSuggested: "Auf {currency} umstellen",
    other: "Andere wählen",
    keep: "{currency} behalten",
  },
};
